export default __webpack_public_path__ + "static/media/7-shine.4faa54b8.png";